import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StyledHeader } from './styles';
import HeaderSection from '../../../containers/MenuManager/Header/Section';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { MenuItem, MenuItemType, MenuModes, MenuPosition } from '../../../typings/menu';
import UserAgentUtils from '../../../utils/userAgent';
import { DriveItemListOrigin } from '../../../containers/DriveItemListPage/constants';

interface HeaderProps {
	driveItems?: Api.DriveItem[];
	galleryConfig: Api.Config;
	menuModes: MenuModes;
	dispatch: Dispatch<StoreState>;
	isShareable: boolean;
	isDownloadable: boolean;
	origin: string;
	isMultiApp: boolean;
	isReadOnlyApp: boolean;
	hasLastPublication: boolean;
}

class Header extends React.Component<HeaderProps, {}> {
	filterMenuItems(menuItems: MenuItem[]): MenuItem[] {
		const {
			galleryConfig,
			origin,
			driveItems,
			isDownloadable,
			isShareable,
			isMultiApp,
			isReadOnlyApp,
			hasLastPublication,
		} = this.props;
		const hasDriveItems = driveItems !== undefined && driveItems.length > 0;

		if (menuItems) {
			return menuItems.filter((item) => {
				switch (item.type) {
					case MenuItemType.New:
						return UserAgentUtils.isOnline() || !Utils.isMaster(galleryConfig);
					case MenuItemType.Downloads:
						return UserAgentUtils.isMobileApp;
					case MenuItemType.DownloadButton:
						return origin !== DriveItemListOrigin.Downloads && hasDriveItems && isDownloadable;
					case MenuItemType.ShareButton:
						return hasDriveItems && isShareable;
					case MenuItemType.Documents:
						return isMultiApp && !isReadOnlyApp;
					case MenuItemType.SharedWithMe:
						return isMultiApp;
					case MenuItemType.BackToPublication:
						return hasLastPublication;
					default:
						return item;
				}
			});
		}
		return [];
	}

	render() {
		const { driveItems, menuModes } = this.props;

		return (
			<>
				{menuModes &&
					<StyledHeader className="StyledHeader">
						<HeaderSection position={MenuPosition.left} menuItems={this.filterMenuItems(menuModes.left)} driveItems={driveItems} />
						<HeaderSection position={MenuPosition.center} menuItems={this.filterMenuItems(menuModes.center)} driveItems={driveItems} />
						<HeaderSection position={MenuPosition.right} menuItems={this.filterMenuItems(menuModes.right)} driveItems={driveItems} />
					</StyledHeader>
				}
			</>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/index.tsx